<template>
  <div
    class="flex flex-col space-y-10 xl:flex-row xl:space-y-0"
    data-component="offices"
  >
    <div class="w-10/12 mx-auto xl:w-3/12">
      <h2 class="font-serif text-3xl xl:leading-tight xl:text-5xl xl:mb-10">
        {{ officesData.offices.length }}
        <template v-if="officesData.lang === 'nl'">
          lokale kantoren
        </template>
        <template v-if="officesData.lang === 'fr'">
          agences locales
        </template>
      </h2>
      <ul class="hidden space-y-6 xl:block">
        <li
          v-for="(office, index) in officesData.offices"
          :key="office.id"
        >
          <a
            href="#"
            :class="`text-base tracking-wider uppercase btn-link ${
              index === activeTab ? 'is-line' : 'opacity-50 hover:opacity-100'
            }`"
            @click.prevent.stop="setTab(index)"
          >
            {{ office.title }}
          </a>
        </li>
      </ul>
    </div>
    <div class="xl:w-9/12">
      <vue-glide
        v-model="activeTab"
        :options="glideOptions"
      >
        <vue-glide-slide
          v-for="office in officesData.offices"
          :key="office.id"
        >
          <div
            class="flex flex-col pr-6 xl:flex-row-reverse xl:items-end xl:pb-28"
          >
            <div class="relative z-0 w-full xl:w-1/2">
              <div class="w-full">
                <div class="relative">
                  <div class="aspect-ratio-4/3" />
                  <img
                    class="absolute top-0 left-0 z-0 object-cover object-center w-full h-full lazy"
                    :data-src="office.meta.images[0].sizes.medium"
                  >
                </div>
              </div>
            </div>

            <div class="relative z-10 w-full xl:w-1/2 xl:-right-1/4">
              <div
                :class="`p-8 pb-12 xl:-mb-28 xl:p-14 xl:shadow-xl bg-opacity-95 ${
                  !officesData.light
                    ? 'bg-white text-brand-500'
                    : 'bg-brand-500 text-white'
                }`"
              >
                <p class="mb-5 text-base tracking-wider uppercase xl:mb-8">
                  {{ office.title }}
                </p>

                <ul class="mb-8 space-y-6 font-light xl:mb-10">
                  <li class="flex">
                    <i class="w-8 fas fa-map-marker-alt text-danger-500" />
                    <a
                      :href="office.meta.office_details.google_maps"
                      target="_blank"
                      class="-mt-1 transition duration-200 hover:text-danger-500"
                    >
                      <p>{{ office.meta.office_details.street }}</p>
                      <p>{{ office.meta.office_details.city }}</p>
                    </a>
                  </li>
                  <li class="flex">
                    <i class="w-8 fas fa-phone text-danger-500" />
                    <div class="-mt-1">
                      <a
                        :href="`tel:${office.meta.office_details.phone}`"
                        class="transition duration-200 hover:text-danger-500"
                      >{{ office.meta.office_details.phone }}</a>
                    </div>
                  </li>
                </ul>

                <a
                  :href="office.permalink"
                  class="btn btn-danger"
                >
                  <template v-if="officesData.lang === 'nl'">Ontdek ons kantoor</template>
                  <template v-if="officesData.lang === 'fr'">Decouvrez cette agence</template>
                </a>
              </div>
            </div>
          </div>
        </vue-glide-slide>
      </vue-glide>
    </div>
  </div>
</template>

<script>
import LazyLoad from "vanilla-lazyload";
import { Glide, GlideSlide } from "vue-glide-js";

export default {
  components: {
    [Glide.name]: Glide,
    [GlideSlide.name]: GlideSlide,
  },
  data() {
    return {
      officesData: window.officesData,
      activeTab: 0,
      glideOptions: {
        type: "carousel",
        perView: 1,
        gap: 0,
        keyboard: false,
        animationDuration: 300,
        breakpoints: {
          1023: {
            gap: 15,
            peek: {
              before: 30,
              after: 30,
            },
          },
        },
      },
    };
  },
  mounted() {
    new LazyLoad({
      elements_selector: ".lazy",
      unobserve_entered: true,
    });
  },
  methods: {
    setTab(id) {
      this.activeTab = id;
    },
  },
};
</script>

<style>
[data-component="offices"] .glide__slide {
  @apply opacity-50 transition-all;
}

[data-component="offices"] .glide__slide.glide__slide--active {
  @apply opacity-100;
}
</style>
